import React from "react";
import Waypoint from "react-waypoint";
import { inject, observer } from "mobx-react";

const ScrollNotifier = ({
  offset = "0px",
  onEnter,
  onLeave,
  updateBackground
}) => (
  <Waypoint
    bottomOffset={offset}
    onEnter={onEnter ? () => updateBackground(onEnter) : () => null}
    onLeave={onLeave ? () => updateBackground(onLeave) : () => null}
  />
);

export default inject(({ store }) => ({
  scroll: store.uiStore.scroll,
  background: store.appStore.background1,
  updateBackground: store.appStore.updateBackground
}))(observer(ScrollNotifier));



// WEBPACK FOOTER //
// ./src/components/ScrollNotifier/index.js